export const currentTechStack = [
  {
    id: 'nodejs',
    name: 'Node.js',
  },
  {
    id: 'typescript',
    name: 'TypeScript',
  },
  {
    id: 'react',
    name: 'React',
  },
  {
    id: 'nextjs',
    name: 'Next.js',
  },
  {
    id: 'aws',
    name: 'AWS',
  },
  {
    id: 'graphql',
    name: 'GraphQL',
  },
  {
    id: 'mongodb',
    name: 'MongoDB',
  },
  {
    id: 'postgresql',
    name: 'PostgreSQL',
  },
]

export const learningNew = [
  {
    id: 'remix',
    name: 'Remix',
  },
  {
    id: 'go',
    name: 'Go',
  },
]
